<template>
  <nav>
    <vue-paginate
      v-model="page"
      container-class="pagination justify-content-center"
      :page-count="totalPage"
      :page-range="5"
      prev-text="«"
      next-text="»"
      page-class="page-item"
      page-link-class="page-link"
      prev-link-class="page-link"
      next-link-class="page-link"
      :click-handler="callback"
    ></vue-paginate>
  </nav>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Paginate',
  props: ['totalPage', 'callback'],
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    ...mapGetters({
      currentPage: 'getPage',
    }),
  },
  methods: {
    ...mapMutations({
      setPage: 'setPage',
    }),
  },
  watch: {
    currentPage(value) {
      this.page = value;
    },
  },
  mounted() {
    this.page = this.currentPage;
  },
};
</script>

<style scoped>
</style>
